"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _glamor = require("glamor");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _InternalContext = _interopRequireDefault(require("./InternalContext"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var ROOT_CSS = (0, _glamor.css)({
  height: '100%',
  overflowY: 'auto',
  width: '100%'
});
var Panel = function Panel(_ref) {
  var children = _ref.children,
    className = _ref.className,
    setTarget = _ref.setTarget;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(ROOT_CSS + '', (className || '') + ''),
    ref: setTarget
  }, children);
};
var _default = function _default(props) {
  return _react.default.createElement(_InternalContext.default.Consumer, null, function (_ref2) {
    var setTarget = _ref2.setTarget;
    return _react.default.createElement(Panel, _extends({
      setTarget: setTarget
    }, props));
  });
};
exports.default = _default;